import { Component } from "react"

/* Components */
import { Menu, MobileTab, Header, Background, MainLoading } from "../components"

/* Router */
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"

/* Redux */
import { Provider } from "react-redux"
import { store } from "../store"

/* Helpers */
import { ProtectedRoute } from "../helpers"

/* SOCKET.IO */
import { io } from "socket.io-client"

/* Constants */
import { env } from "../constants"

/* Pages */
import Page404 from "../pages/Page404"
import { Dashboard } from "../pages/Dashboard"
import { Games, GameCreate, MultiGame, VipGame, RouletteGame, VipThreeBox, REPGame, R2EPGame, SEPGame, OEPGame, QEPGame, UEPGame, HEPGame, EEPGame, NEPGame, JEPGame, EB1Game, EABGame, EPBGame } from "../pages/Game"
import { Profile, Password, History } from "../pages/Profile"
import { Dealers, DealerCreate, DealerEdit } from "../pages/Dealer"
import { Currencies, CurrencyCreate, CurrencyEdit } from "../pages/Currency"
import { Cards, CardEdit } from "../pages/Card"
import { Messages } from "../pages/Message"
import { Players } from "../pages/Player"
import { Roles, RoleCreate, RoleEdit } from "../pages/Role"
import { Admins, AdminCreate, AdminEdit, AdminChangePassword, AdminHistory, AdminActivity, AdminAccept } from "../pages/Admin"
import { Operators, OperatorCreate, OperatorEdit, OperatorAccept } from "../pages/Operator"
import { Notifications } from "../pages/Notification"
import { Bonus } from "../pages/Bonus"
import { Studio } from "../pages/Studio"



/* Layout Widget */
class Layout extends Component {

    constructor() {
        super()

        const minimized = localStorage.getItem("minimized")
        const token = localStorage.getItem("token")

        this.state = {
            minimized: minimized && minimized === "yes",
        }

        this.socket = io(env.socketpoint, { auth: { token: `${token}`, type: "admin" } })
    }

    componentWillUnmount = () => {
        this.socket.disconnect()
    }

    /* Toggle Menu */
    toggleMenu = (value) => {

        this.setState({ minimized: value })

        if (value) {
            localStorage.setItem("minimized", "yes")
        }
        else {
            localStorage.removeItem("minimized")
        }

    }


    render = () => {

        /* Fields */
        const { minimized } = this.state
        const { setToken, token } = this.props

        return (
            <Provider store={store}>
                <MainLoading token={token}>
                    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                        <div className="app">

                            <Menu minimized={minimized} toggle={() => this.toggleMenu(!minimized)} />

                            <div className={`container ${minimized ? "minimized" : "full-container"}`}>

                                <Header socket={this.socket} setToken={setToken} />

                                <Routes>

                                    <Route path="*" element={<ProtectedRoute setToken={setToken}><Page404 /></ProtectedRoute>} />
                                    <Route path="/" element={<ProtectedRoute setToken={setToken}><Dashboard /></ProtectedRoute>} />

                                    {/* Game */}
                                    <Route path="/notifications" element={<ProtectedRoute setToken={setToken}><Notifications /></ProtectedRoute>} />
                                    <Route path="/notifications/:page" element={<ProtectedRoute setToken={setToken}><Notifications /></ProtectedRoute>} />

                                    {/* RUSSIAN MULTIPOKER */}
                                    <Route path="/table/russian-multipoker/:uid" element={<MultiGame postfix="RMP" />} />

                                    {/* LUNAR MULTIPOKER */}
                                    <Route path="/table/lunar-multipoker/:uid" element={<MultiGame postfix="LMP" />} />

                                    {/* NOVO MULTIPOKER */}
                                    <Route path="/table/novo-multipoker/:uid" element={<MultiGame postfix="NMP" />} />

                                    {/* OPEN MULTIPOKER */}
                                    <Route path="/table/open-multipoker/:uid" element={<MultiGame postfix="OMP" />} />

                                    {/* QUEEN MULTIPOKER */}
                                    <Route path="/table/queen-multipoker/:uid" element={<MultiGame postfix="QMP" />} />

                                    {/* EUROPEAN MULTIPOKER */}
                                    <Route path="/table/european-multipoker/:uid" element={<MultiGame postfix="EMP" />} />

                                    {/* ULTIMATE MULTIPOKER */}
                                    <Route path="/table/ultimate-multipoker/:uid" element={<MultiGame postfix="UMP" />} />

                                    {/* CASINO HOLDEM */}
                                    <Route path="/table/holdem-multipoker/:uid" element={<MultiGame postfix="HMP" />} />

                                    {/* RUSSIAN VIP POKER */}
                                    <Route path="/table/russian-vip-poker/:uid" element={<VipGame postfix="RVP" />} />

                                    {/* RUSSIAN VIP POKER */}
                                    <Route path="/table/queen-vip-poker/:uid" element={<VipGame postfix="QVP" />} />

                                    {/* RUSSIAN VIP POKER */}
                                    <Route path="/table/european-vip-poker/:uid" element={<VipGame postfix="EVP" />} />

                                    {/* ROULETTE 1 */}
                                    <Route path="/table/roulette-1/:uid" element={<RouletteGame postfix="RO1" />} />

                                    {/* VIP ULTIMATE TEXAS HOLD'EM */}
                                    <Route path="/table/vip-ultimate-texas-holdem-vip/:uid" element={<VipThreeBox postfix="UVP" />} />


                                    {/* RUSSIAN ELECTRON POKER */}
                                    <Route path="/table/russian-electron-poker/:uid" element={<REPGame />} />

                                    {/* RUSSIAN TWO BOX ELECTRON POKER */}
                                    <Route path="/table/russian-two-box-electron-poker/:uid" element={<R2EPGame />} />

                                    {/* SUPER ELECTRON POKER */}
                                    <Route path="/table/super-electron-poker/:uid" element={<SEPGame />} />

                                    {/* OPEN ELECTRON POKER */}
                                    <Route path="/table/open-electron-poker/:uid" element={<OEPGame />} />

                                    {/* ELECTRON QUEEN OF SPADES */}
                                    <Route path="/table/queen-electron-poker/:uid" element={<QEPGame />} />

                                    {/* ELECTRON ULTIMATE TEXAS HOLD"EM */}
                                    <Route path="/table/ultimate-electron-poker/:uid" element={<UEPGame />} />

                                    {/* ELECTRON EUROPEAN POKER */}
                                    <Route path="/table/european-electron-poker/:uid" element={<EEPGame />} />

                                    {/* ELECTRON CASINO HOLD"EM */}
                                    <Route path="/table/casino-holdem-electron-poker/:uid" element={<HEPGame />} />

                                    {/* ELECTRON NOVA POKER */}
                                    <Route path="/table/nova-electron-poker/:uid" element={<NEPGame />} />

                                    {/* ELECTRON J POKER */}
                                    <Route path="/table/j-electron-poker/:uid" element={<JEPGame />} />

                                    {/* ELECTRON BLACKJACK ONE */}
                                    <Route path="/table/blackjack-one-electron/:uid" element={<EB1Game />} />

                                    {/* ELECTRON ANDAR BAHAR */}
                                    <Route path="/table/electron-andar-bahar/:uid" element={<EABGame />} />

                                    {/* ELECTRON PUNTO BANCO */}
                                    <Route path="/table/electron-punto-banco/:uid" element={<EPBGame />} />

                                    {/* ELECTRON BLACKJACK FIVE BOX */}
                                    <Route path="/table/electron-blackjack-five-box/:uid" element={<EPBGame />} />

                                    {/* Game */}
                                    <Route path="/game" element={<ProtectedRoute setToken={setToken}><Games /></ProtectedRoute>} />
                                    <Route path="/game/create" element={<ProtectedRoute setToken={setToken}><GameCreate /></ProtectedRoute>} />

                                    {/* Player Routes */}
                                    <Route path="/player" element={<ProtectedRoute setToken={setToken}><Players /></ProtectedRoute>} />
                                    <Route path="/player/:page" element={<ProtectedRoute setToken={setToken}><Players /></ProtectedRoute>} />

                                    {/* Operators */}
                                    <Route path="/studio" element={<ProtectedRoute setToken={setToken}><Studio /></ProtectedRoute>} />

                                    {/* Bonus Routes */}
                                    <Route path="/bonus" element={<ProtectedRoute setToken={setToken}><Bonus socket={this.socket} /></ProtectedRoute>} />

                                    {/* Message Routes */}
                                    <Route path="/message" element={<ProtectedRoute setToken={setToken}><Messages /></ProtectedRoute>} />
                                    <Route path="/message/:page" element={<ProtectedRoute setToken={setToken}><Messages /></ProtectedRoute>} />

                                    {/* Card Routes */}
                                    <Route path="/card" element={<ProtectedRoute setToken={setToken}><Cards /></ProtectedRoute>} />
                                    <Route path="/card/:page" element={<ProtectedRoute setToken={setToken}><Cards /></ProtectedRoute>} />
                                    <Route path="/card/edit/:id" element={<ProtectedRoute setToken={setToken}><CardEdit /></ProtectedRoute>} />

                                    {/* Dealer Routes */}
                                    <Route path="/dealer" element={<ProtectedRoute setToken={setToken}><Dealers /></ProtectedRoute>} />
                                    <Route path="/dealer/:page" element={<ProtectedRoute setToken={setToken}><Dealers /></ProtectedRoute>} />
                                    <Route path="/dealer/create" element={<ProtectedRoute setToken={setToken}><DealerCreate /></ProtectedRoute>} />
                                    <Route path="/dealer/edit/:id" element={<ProtectedRoute setToken={setToken}><DealerEdit /></ProtectedRoute>} />

                                    {/* Currency Routes */}
                                    <Route path="/currency" element={<ProtectedRoute setToken={setToken}><Currencies /></ProtectedRoute>} />
                                    <Route path="/currency/:page" element={<ProtectedRoute setToken={setToken}><Currencies /></ProtectedRoute>} />
                                    <Route path="/currency/create" element={<ProtectedRoute setToken={setToken}><CurrencyCreate /></ProtectedRoute>} />
                                    <Route path="/currency/edit/:id" element={<ProtectedRoute setToken={setToken}><CurrencyEdit /></ProtectedRoute>} />

                                    {/* Profile Route */}
                                    <Route path="/profile" element={<ProtectedRoute setToken={setToken}><Profile /></ProtectedRoute>} />
                                    <Route path="/change-password" element={<ProtectedRoute setToken={setToken}><Password /></ProtectedRoute>} />
                                    <Route path="/history" element={<ProtectedRoute setToken={setToken}><History /></ProtectedRoute>} />

                                    {/* Role */}
                                    <Route path="/user" element={<ProtectedRoute setToken={setToken}><Admins /></ProtectedRoute>} />
                                    <Route path="/user/:page" element={<ProtectedRoute setToken={setToken}><Admins /></ProtectedRoute>} />
                                    <Route path="/user/create" element={<ProtectedRoute setToken={setToken}><AdminCreate /></ProtectedRoute>} />
                                    <Route path="/user/edit/:id" element={<ProtectedRoute setToken={setToken}><AdminEdit /></ProtectedRoute>} />
                                    <Route path="/user/password/:id" element={<ProtectedRoute setToken={setToken}><AdminChangePassword /></ProtectedRoute>} />
                                    <Route path="/user/history/:id" element={<ProtectedRoute setToken={setToken}><AdminHistory /></ProtectedRoute>} />
                                    <Route path="/user/activity/:id" element={<ProtectedRoute setToken={setToken}><AdminActivity /></ProtectedRoute>} />
                                    <Route path="/user/accept/:id" element={<ProtectedRoute setToken={setToken}><AdminAccept /></ProtectedRoute>} />

                                    {/* Operator */}
                                    <Route path="/operator" element={<ProtectedRoute setToken={setToken}><Operators /></ProtectedRoute>} />
                                    <Route path="/operator/:page" element={<ProtectedRoute setToken={setToken}><Operators /></ProtectedRoute>} />
                                    <Route path="/operator/create" element={<ProtectedRoute setToken={setToken}><OperatorCreate /></ProtectedRoute>} />
                                    <Route path="/operator/edit/:id" element={<ProtectedRoute setToken={setToken}><OperatorEdit /></ProtectedRoute>} />
                                    <Route path="/operator/accept/:id" element={<ProtectedRoute setToken={setToken}><OperatorAccept /></ProtectedRoute>} />


                                    {/* Role */}
                                    <Route path="/role" element={<ProtectedRoute setToken={setToken}><Roles /></ProtectedRoute>} />
                                    <Route path="/role/:page" element={<ProtectedRoute setToken={setToken}><Roles /></ProtectedRoute>} />
                                    <Route path="/role/create" element={<ProtectedRoute setToken={setToken}><RoleCreate /></ProtectedRoute>} />
                                    <Route path="/role/edit/:id" element={<ProtectedRoute setToken={setToken}><RoleEdit /></ProtectedRoute>} />

                                </Routes>

                            </div>

                            <MobileTab />

                        </div>

                        <Background />

                    </Router>
                </MainLoading>
            </Provider>
        )
    }

}

export default Layout